
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[_network]/supertokens",
      function () {
        return require("private-next-pages/[_network]/supertokens/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[_network]/supertokens"])
      });
    }
  